module.exports = __webpack_public_path__ + "assets/img/warrior-name-3ff06c1d.png";